import React, { useState, useRef } from 'react';
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

// Helper function to generate cropped image
function getCroppedImg(image, crop, fileName) {
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  canvas.width = crop.width;
  canvas.height = crop.height;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height
  );

  return new Promise((resolve, reject) => {
    // モバイルブラウザ対応: toBlob()が失敗する場合がある
    if (canvas.toBlob) {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            console.error('Canvas is empty');
            return reject(new Error('Canvas is empty'));
          }
          blob.name = fileName;
          resolve(blob);
        },
        'image/jpeg',
        0.95
      );
    } else {
      // toBlob非対応ブラウザ用フォールバック
      try {
        const dataUrl = canvas.toDataURL('image/jpeg', 0.95);
        const blob = dataURLToBlob(dataUrl);
        blob.name = fileName;
        resolve(blob);
      } catch (error) {
        reject(new Error(`画像変換エラー: ${error.message}`));
      }
    }
  });
}

// DataURLをBlobに変換（フォールバック用）
function dataURLToBlob(dataURL) {
  const arr = dataURL.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

const ImageCropModal = ({
  src,
  onCropComplete,
  onCancel,
  aspect = 1,
  circularCrop = false,
}) => {
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const imgRef = useRef(null);

  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    const initialCrop = centerCrop(
      makeAspectCrop(
        {
          unit: '%',
          width: 90,
        },
        aspect, // Use passed aspect ratio
        width,
        height
      ),
      width,
      height
    );
    setCrop(initialCrop);
  };

  const handleApplyCrop = async () => {
    if (completedCrop?.width && completedCrop?.height && imgRef.current) {
      const croppedImageBlob = await getCroppedImg(
        imgRef.current,
        completedCrop,
        'cropped-image.jpeg'
      );
      onCropComplete(croppedImageBlob);
    }
  };

  if (!src) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-[10002] p-4">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col">
        <h2 className="text-2xl font-bold mb-4">画像の切り抜き</h2>
        <p className="mb-4 text-gray-600">表示したい領域を選択してください。</p>
        <div className="flex justify-center bg-gray-100 p-4 rounded-md overflow-auto flex-1">
          <ReactCrop
            crop={crop}
            onChange={(c) => setCrop(c)}
            onComplete={(c) => setCompletedCrop(c)}
            aspect={aspect}
            circularCrop={circularCrop}
            className="max-h-[50vh]"
          >
            <img
              ref={imgRef}
              src={src}
              onLoad={onImageLoad}
              alt="Crop preview"
            />
          </ReactCrop>
        </div>
        <div className="mt-6 flex justify-end space-x-4 flex-shrink-0 pb-safe">
          <button
            onClick={onCancel}
            className="px-6 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300 transition-colors"
          >
            キャンセル
          </button>
          <button
            onClick={handleApplyCrop}
            className="px-6 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors"
          >
            切り抜きを適用
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageCropModal;
